module.exports = __webpack_public_path__ + "media/images/LOGO_NHC-0746d90ab8df10ce5a2d5339b857cd83.svg";